// Fields config by market

/* eslint-disable no-useless-escape */

export const MARKET_REGEXP_EMAIL = {
    DEFAULT: /^[^\s@]+@[^\s\.@]+(\.[^\s\.@]+)+$/,
};

export const MARKET_REGEXP_MOBILE = {
    DEFAULT: /^\d{9,15}$/,
    CH: /^07[4-9]\d{7}$/,
    DE: [
        [/^01609/, /^01609\d{7}$/],
        [/^0176/, /^0176\d{8}$/],
        [/^0/, /^0(15\d{9}|16\d{8}|17\d{8})$/],
    ],
};

export const MARKET_REGEXP_CITY = {
    DEFAULT: /^.{0,40}$/,
};

export const MARKET_REGEXP_POSTAL = {
    DEFAULT: /^[0-9]{0,20}$/,
    DE: /^[0-9]{5}$/,
};

export const MARKET_VALUES_COUNTRY = {
    CH: ['CH'],
    DE: ['DE'],
    EC: ['EC'],
};

export const MARKET_VALUES_LANGUAGE = {
    CH: ['de', 'fr'],
    DE: ['de'],
    EC: ['es'],
};

export const MARKET_FORMAT_DATE = {
    DEFAULT: 'DD-MM-YYYY',
};

export const MARKET_FORMAT_DATETIME = {
    DEFAULT: 'DD-MM-YYYY HH:mm:ss',
};

export const MARKET_ACTIONS = {
    resetPassword: {
        DEFAULT: true,
        DE: false,
    },
    havUpdate: {
        DEFAULT: true,
        DE: false,
    },
};

export const MARKET_FIELDS = {
    email: {
        DEFAULT: { editable: false, required: false },
        CH: { editable: true, required: true },
    },
};

export const MARKET_CONFIG_BRANDS = {
    DEFAULT: {
        brand: { editable: true, required: true },
        subBrand: { editable: true, required: true },
    },
    DE: { brand: { editable: false } },
    EC: { brand: { editable: false } },
};

export const MARKET_SEARCH_LIMIT = {
    DEFAULT: null,
    EC: 100,
};

export function getMarketValue(valueMap, market) {
    return valueMap && Object.hasOwn(valueMap, market)
        ? valueMap[market]
        : valueMap.DEFAULT;
}
